import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';

import { ReportsComponent } from './reports.component';
import { ReportChartComponent } from './report-wrapper/report-chart/report-chart.component';
import { ReportSelectFormComponent } from './report-select-form/report-select-form.component';
import { ReportExportCracComponent } from './report-export-crac/report-export-crac.component';
import { ReportWrapperComponent } from './report-wrapper/report-wrapper.component';
import { ReportSimuComponent } from './report-simu/report-simu.component';
import { ReportCompareComponent } from './report-compare/report-compare.component';
import { ReportPrintComponent } from './report-wrapper/report-print/report-print.component';
import { CustomSimuComponent } from './report-wrapper/report-custom/custom-simu/custom-simu.component';
import { CustomCompareComponent } from './report-wrapper/report-custom/custom-compare/custom-compare.component';
import { ReportCustomComponent } from './report-wrapper/report-custom/report-custom.component';
import { ReportDatatableComponent } from './report-wrapper/report-datatable/report-datatable.component';
import { ReportSampleComponent } from './report-wrapper/report-sample/report-sample.component';
import { ReportVariationSelectComponent } from './report-wrapper/report-variation-select/report-variation-select.component';
import { ReportSystemComponent } from './report-system/report-system.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule
  ],
  declarations: [
      ReportsComponent,
      ReportChartComponent,
      ReportSelectFormComponent,
      ReportExportCracComponent,
      ReportWrapperComponent,
      ReportSimuComponent,
      ReportCompareComponent,
      ReportPrintComponent,
      CustomSimuComponent,
      CustomCompareComponent,
      ReportCustomComponent,
      ReportDatatableComponent,
      ReportSampleComponent,
      ReportVariationSelectComponent,
      ReportSystemComponent
    ],
    exports: [
        ReportChartComponent
    ]
})
export class ReportModule { }
